import React, { Component } from 'react';
import TableRow from '@mui/material/TableRow';
import TableCell from '@mui/material/TableCell';
import PropTypes from 'prop-types';
import { withStyles } from '@mui/styles';
import { lighten  } from '@mui/material/styles';
import DataCell from './DataCell';
import RowCheckbox from './RowCheckbox';
import {
  density,
  getDensityClass,
  getCheckboxWidth
} from './utils/density';
import { composeLink } from '../../utils/link';

const styles = theme => ({
  row: {
  },
  selected: {
    background: lighten(theme.palette.primary.light, 0.85)
  },
    ...density
});

class DataRow extends Component {

  rowCells = (dataRow) => {
    const { settings, columns } = this.props;
    const row = dataRow.data;
    return columns.map(col => {
      if (!col.visible) {
        return false;
      }
      return (
        <DataCell
          value={row[col.id] || ''}
          id={col.id}
          dataRow={dataRow}
          key={col.id}
          numeric={col.numeric || false}
          currency={col.currency || false}
          date={col.date || false}
          link={col.link ? composeLink(col.link, row) : false}
          editable={col.editable || false}
          badge={col.badge || false}
          badge2={col.badge2 || false}
          select={col.select || false}
          long={col.long || false}
          onEdit={this.handleCellEdit}
          settings={settings}
        />
      );
    });
  };

  handleCellEdit = (dataRow, id, value, done) => {
    const { onCellEdit } = this.props;
    if (onCellEdit) {
      onCellEdit(dataRow.data, id, value, done);
    }
  };

  repaint = () => {
    this.setState({});
  };

  handleSelect = (event, key) => {
    const { dataRow, oneSelected, handleMultiSelect } = this.props;
    if (dataRow.data.name === '{PLACEMENT}') {
      // cannot select placements from package grid
    } else if (oneSelected && event.shiftKey) {
      handleMultiSelect(oneSelected, dataRow.data.id)
    } else if (event.shiftKey) {
      // cannot pick which row so ignore the shift key
    } else {
      dataRow.selected = !dataRow.selected;
      this.repaint();
      if (this.props.onSelect) {
        this.props.onSelect(key);
      }
    }
  };

  render() {
    const {
      dataRow,
      classes,
      selectable,
      settings
    } = this.props;
    const isSelected = dataRow.selected;
    this.chkBoxRef = React.createRef();
    this.trRef = React.createRef();

    return (
      <TableRow ref={this.trRef}
        hover
        role="checkbox"
        aria-checked={isSelected}
        tabIndex={-1}
        classes={{
          root: getDensityClass(classes, 'Row', settings.density)
        }}
        className={isSelected ? classes.selected : null}
      >
        {(selectable) ? (
          <TableCell
            padding="checkbox"
            style={getCheckboxWidth(settings.density)}
            classes={{
              root: getDensityClass(classes, 'Cell', settings.density),
              paddingCheckbox: getDensityClass(classes, 'CheckboxCell', settings.density)
            }}
          >
            <RowCheckbox
              ref={this.chkBoxRef}
              key={`${dataRow.key}-${isSelected}`}
              classes={{
                root: getDensityClass(classes, 'Checkbox', settings.density)
              }}
              type="checkbox"
              color="primary"
              selected={isSelected}
              onClick={event => this.handleSelect(event, dataRow.key)}
            />
          </TableCell>
        ): null
          }
        {this.rowCells(dataRow)}
      </TableRow>
    );
  }
}

DataRow.defaultProps = {
  oneSelected: null
};

DataRow.propTypes = {
  dataRow: PropTypes.object.isRequired,
  oneSelected: PropTypes.number,
  handleMultiSelect: PropTypes.func.isRequired
};

export default withStyles(styles, { withTheme: true })(DataRow);
